const Footer = () => {
    return (
      <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-gray-300 py-6 mt-10 text-center shadow-lg relative overflow-hidden">
        {/* Floating Animation Effect */}
        <div className="absolute inset-0 opacity-10">
          <div className="w-36 h-36 bg-blue-500 blur-3xl rounded-full absolute top-10 left-20 animate-pulse"></div>
          <div className="w-24 h-24 bg-purple-500 blur-2xl rounded-full absolute bottom-10 right-20 animate-pulse"></div>
        </div>
  
        <div className="container mx-auto px-6 relative z-10">
          {/* Copyright Text with Hover Effect */}
          <p className="text-sm font-medium transition-transform duration-500 hover:scale-105">
            &copy; {new Date().getFullYear()} <span className="text-blue-400 font-bold">ADSPACE PVT LTD</span>. All Rights Reserved.
          </p>
  
          {/* Version & Update Info with Hover Glow */}
          <p className="text-xs text-gray-400 mt-2">
            <span className="hover:text-blue-400 transition-colors duration-300 hover:shadow-glow">v1.891</span> | Updated on:  
            <span className="hover:text-purple-400 transition-colors duration-300 hover:shadow-glow"> Mar 2025</span>
          </p>
        </div>
      </footer>
    );
  };
  
  export default Footer;
  